module.exports = __webpack_public_path__ + "img/orbital_sander_and_finishing_pad.10493cc5.webp";